<template>
  <chart :options="chartOptions" style="height: 100%; position: relative;" />
</template>

<script>
  // import CategoricalInsightContainer from './CategoricalInsightContainer';
  import {Chart} from 'highcharts-vue';


  export default {
    name: 'CategoricalModalInsight',

    components: {Chart},

    props: {
      width: Number,
      selectedChartType: String,
      chartOptions: Object,
      widthColumns: Number
    },

    data() {
      return {
        chartData: []
      };
    },

    mounted() {
      if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }
    },

    methods: {
      
    },

    computed: {
      innerStyle() {
        const spacing = "20px 4px";
        return {
          height: `${CATEGORICAL_INSIGHT_HEIGHT}px`,
          width: `calc(100% - ${spacing} * 2)`,
          margin: spacing,
          position: "relative"
        };
      }
    }
  };
</script>

<style scoped lang="sass">
  .fullscreen-modal
    width: 100% !important
    height: 100% !important

  @media (min-width: 1200px)
    .modal-xl
      max-width: auto !important;

  @media (min-height: 600px)
    .modal-xl
      max-height: 80% !important;

  @media (min-width: 992px)
    .modal-lg, .modal-xl
      max-width: auto !important;

  @media (min-width: 992px)
    .modal-dialog
      max-width: auto !important;

  .card-style
    margin: 0

  .card-header-padding
    padding: 0

  @for $i from 1 through 4
    .insight-cols-#{$i}
      width: $i * 25%
      max-width: 100%
      z-index: 0

  @media (max-width: 480px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: $i * 50%
        z-index: 0

  @media (max-width: 320px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: 100%
        z-index: 0

</style>
